// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4J1oY","content":"styles_content__Fc5x0","tableWrap":"styles_tableWrap__2SNFQ"};